import $ from "jquery";

export const handleAddTarget = () => {
    $('.material-content__part  a[href^="http"]').each((index, element) => {
        if ($(element).attr("href").indexOf(window.location.origin) === -1)
            $(element).attr("target", "_blank");
    });
};
